/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { User } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface RoleUsersServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Add the user to the role
     * Add the user to the role (specified by id)
     * @param roleId The id of the role to add the user to.
     * @param user The ID of the user to whom the role will be added
     */
    addRoleUser(roleId: number, user: User, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Get role users
     * Returns all users with this role (by role id)
     * @param roleId The id of the role to fetch.
     */
    getRoleUsersByRoleId(roleId: number, extraHttpRequestParams?: any): Observable<Array<User>>;

    /**
     * Remove the role from the user
     * Remove the role (specified by role id) from the user
     * @param roleId The id of the role to remove.
     * @param user The ID of the user whose role is being removed
     */
    removeRoleFromUser(roleId: number, user: User, extraHttpRequestParams?: any): Observable<{}>;

}
